import PageTitle from "../../components/PageTitle";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import PageContent from "../../components/PageContent";
import useApi from "../../hooks/ApiHook";
import { useEffect, useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import usePaginator from "../../hooks/PaginatorHook";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Dropdown } from 'primereact/dropdown';

export default function() {

    const api = useApi();
    const [ products, setProducts ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const { page, limit, setPage, setTotal, Paginator } = usePaginator();
    const [ searchParams, setSearchParams ] = useSearchParams();
    const [ industries, setIndustries ] = useState();
    const [ selectedIndustry, setSelectedStock ] = useState();

    useEffect(() => {
        retrieveStocks();
    }, []);
    
    useEffect(() => {
        retrieveData();
    }, [page, limit, selectedIndustry]);

    useEffect(() => {
        setPage(0);
    }, [selectedIndustry]);

    const retrieveData = () => {
        setLoading(true);
        const params = { page, limit, "owner.id": selectedIndustry?.id }
        api.get(`products`, { params }).then(({ data }) => {
            setProducts(data.data);
            setTotal(data.total);
            setSearchParams({ page, limit });
        }).finally(() => setLoading(false));
    }

    const retrieveStocks = () => {
        api.get(`industries?limit=100`).then(({ data }) => {
            setIndustries(data.data);
        });
    }

    const descriptionTemplate = p => (
        <>
            <div>{p.description}</div>
            <div className="text-xs font-semibold text-color-secondary">{p.owner.commercialName}</div>
        </>
    );

    return (
        <div>
            <PageTitle title="Produtos" subtitle="Quantidades de produtos em estoque e as respectivas indústrias"/>
            <PageContent>
                <div className="mb-3 ">
                    <Dropdown
                        options={industries}
                        value={selectedIndustry}
                        optionLabel="commercialName"
                        onChange={e => setSelectedStock(e.value)}
                        placeholder="Distribuidora"
                        showClear={true}
                        disabled={!industries}/>
                </div>
                {loading && <Loading/>}
                {!loading && (
                    <>
                        <DataTable 
                            value={products} 
                            selectionMode="single" 
                            emptyMessage="Nada encontrado">
                            <Column body={descriptionTemplate} header="Descrição"></Column>
                            <Column field="code" header="Código"></Column>
                            <Column body={p => p.quantity + ' ' + p.unit} header="Quantidade"></Column>
                        </DataTable>
                        <Paginator/>
                    </>
                )}
            </PageContent>
        </div>
    );
}